module.exports = require("./ga.d.ts");